// Dev-only logger. Logs in development, silent in production.
const isDev = process.env.NODE_ENV === 'development';

export const devLog = (...args) => {
  if (isDev) console.log('[DEV]', ...args); // eslint-disable-line no-console
};

export const devError = (context, error) => {
  if (isDev) console.error(`[DEV] ${context}:`, error); // eslint-disable-line no-console
};
